import React from "react";
import styles from "./AnotherChannelModal.module.scss";
import ExitIcon from "../../../../assets/icons/ExitIcon";
import CustomInput from "../../../CustomInput/CustomInput";
import CustomButton from "../../../CustomButton/CustomButton";
import { useTranslation } from "react-i18next";

const AnotherChannelModal = ({ setOpenModal }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.modal}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>
            {t("channels.requestNewChannel")}
          </h2>
          <ExitIcon onClick={() => setOpenModal(null)} />
        </div>
        <CustomInput
          placeholder={t("channels.enterNamePlaceholder")}
          label={t("channels.name")}
        />
        <CustomInput
          placeholder={t("channels.enterSocialPlaceholder")}
          label={t("channels.socialNetwork")}
        />
        <CustomInput
          placeholder={t("channels.enterContactPlaceholder")}
          label={t("channels.contact")}
        />
        <div className={styles.modalFooter}>
          <CustomButton onClick={() => setOpenModal(null)}>
            {t("channels.cancel")}
          </CustomButton>
          <CustomButton blue>{t("channels.submit")}</CustomButton>
        </div>
      </div>
    </div>
  );
};

export default AnotherChannelModal;
